import axios from '../../../axios';
import IClientSettings from '../types/IClientSettings';
import IUpdateStatus from '../types/IUpdateStatus';

const url = '/api/';

export const getAllBusinessUnitSettings = () => axios.get(`${url}get-business-units-settings`);

export const getWorkspaceBUUserCount = () => axios.get(`recruitersearch/api/workspaceusers/count`);

export const getWorkspaceBUUsers = (id: string) =>
  axios.post(`recruitersearch/api/business-unit-workspace-users/${id}`);

export const fetchAllActiveBusinessUnits = () =>
  axios.get(`${url}business-units/workspace-settings`);

export const createNewBusinessUnitSettings = (businessUnitEntity: IClientSettings) =>
  axios.post(`${url}create-business-unit-settings`, businessUnitEntity);

export const updateBusinessUnitSettings = (businessUnitEntity: IClientSettings) =>
  axios.put(`${url}update-business-unit-settings`, businessUnitEntity);

export const updateBusinessUnitStatus = (id: string, status: IUpdateStatus) =>
  axios.put(`${url}business-unit/update-status/${id}`, status);

export const getCurrentUserBusinessUnitsCount = () =>
  axios.get(`recruitersearch${url}current-user/business-units/counts`);

export const getBusinessUnitsByIds = (businessUnitIds: string[]) =>
  axios.post(`${url}get-business-unit-by-ids`, businessUnitIds);
